import {IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
export class HsnCodesDTO {
  @ApiProperty()
  // @MaxLength(7, { message: "department id allows maximum 7 characters" })
  //  @Matches(new RegExp("^[a-zA-Z0-9]+$"), '', { message: "Department Code should not include these Charecters !@#$%^&*()_+{}[]:\";'<>?,./~` " })
  @IsNotEmpty({message:"Hsn Code id should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  hsnCodeId: number;
  
  @ApiProperty()
  @IsNotEmpty({message:"Product Id should not be empty"})
  productId: number;

  @ApiProperty()
  @IsNotEmpty({message:"Food Type Id should not be empty"})
  foodTypeId: number;
  @ApiProperty()
  @IsNotEmpty({message:"Value Addition One Id should not be empty"})
  valueAdditionOneId: number;
  @ApiProperty()
  @IsNotEmpty({message:"Value Addition Two Id should not be empty"})
  valueAdditionTwoId: number;
  @ApiProperty()
  @IsNotEmpty({message:"Value Addition Three Id should not be empty"})
  valueAdditionThreeId: number;
  @ApiProperty()
  @IsNotEmpty({message:"Value Addition Four Id should not be empty"})
  valueAdditionFourId: number;
  @ApiProperty()
  @IsNotEmpty({message:"Value Addition Five Id should not be empty"})
  valueAdditionFiveId: number;
  @ApiProperty()
  @IsAlphanumeric()
  @IsOptional()
  @IsNotEmpty({message:"Hsn Code should not be empty"})
  hsnCode: string;
  @ApiProperty()
  @IsAlphanumeric()
  @IsOptional()
  @IsNotEmpty({message:"varient Code should not be empty"})
  variantCode: string;
 

  @ApiProperty()
  isActive: boolean;

  createdAt : Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Created User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
  createdUser : string;

  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
  updatedUser : string;

  @ApiProperty()
  versionFlag : number;

  
}

